<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
//初始化代码
@import '@/assets/css/reset.scss';
//公共样式
@import '@/assets/css/public.scss';
//组件
@import '@/assets/css/template.scss';


</style>

<script>

export default {
  name: 'app',
  components:{},
  computed:{
    
  },
  watch: {
    '$route' () {
      document.title = this.$route.meta.title;
      window.scroll(0,0);
    }
  }
}
</script>
